<template>
  <div class="selector">
    <label
      v-for="tarif in getTarifvertraege"
      :key="tarif.id"
      v-on:click="selectTarifVertrag(tarif.id)"
      :class="[
        activeTarifvertragId === tarif.id ? 'active' : '',
        tarif.under_construction ? 'under-construction' : ''
      ]"
    >
      {{ tarif.valid_from | dateShort }}
      <span v-if="tarif.under_construction" class="draft-badge">Entwurf</span>
    </label>

    <button v-if="mayEdit" class="btn-new-tarifvertrag" @click="showModal = true" title="Neuen Tarifvertrag anlegen">
      + Neu
    </button>

    <create-tarifvertrag-modal
      v-if="showModal"
      @close="showModal = false"
    ></create-tarifvertrag-modal>
  </div>
</template>

<script>
  import CreateTarifvertragModal from './CreateTarifvertragModal.vue'

  export default {
    name: 'TarifVertragSelector',
    components: {
      CreateTarifvertragModal,
    },
    data () {
      return {
        showModal: false,
      }
    },
    computed: {
      getTarifvertraege () {
        return this.$store.getters['tarifvertrag/getTarifvertraege']
      },
      activeTarifvertragId () {
        return this.$store.getters.getActiveTarifvertragId
      },
      mayEdit () {
        return this.$store.getters['tarifvertrag/getMayEdit']
      }
    },
    methods: {
      selectTarifVertrag (tarifVertragId) {
        this.$store.commit('setActiveTarifvertragId', tarifVertragId)
      }
    }
  }
</script>

<style lang="scss">
  .selector {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 4px;
  }

  .selector label.under-construction {
    border: 1px dashed #d39a4a;
    background: #fdf6ec;
  }

  .draft-badge {
    display: inline-block;
    margin-left: 6px;
    padding: 1px 6px;
    font-size: 0.7rem;
    border-radius: 8px;
    background: #d39a4a;
    color: #fff;
    vertical-align: middle;
  }

  .btn-new-tarifvertrag {
    margin-left: 8px;
    padding: 4px 12px;
    border: 1px dashed #4a90d9;
    border-radius: 4px;
    background: transparent;
    color: #4a90d9;
    cursor: pointer;
    font-size: 0.85rem;
    &:hover {
      background: #e8f2fc;
    }
  }
</style>
